import { OptionCard } from './OptionCard'
import { OptionsGrid, OtherInputContainer } from './styles/OptionCardStyles'
import { QuestionTitle, OtherInput } from './styles/SignUpFlowStyles'
import { PARTNER_NICHE_OPTIONS } from '../../constants/partnerSurveyOptions'

interface PartnerSurveyStepNicheProps {
  value: string | null
  otherValue: string
  onChange: (value: string) => void
  onOtherChange: (value: string) => void
}

export function PartnerSurveyStepNiche({
  value,
  otherValue,
  onChange,
  onOtherChange,
}: PartnerSurveyStepNicheProps) {
  return (
    <div>
      <QuestionTitle>What's your primary audience niche?</QuestionTitle>
      <OptionsGrid>
        {PARTNER_NICHE_OPTIONS.map((option) => (
          <div key={option.value}>
            <OptionCard
              label={option.label}
              isSelected={value === option.value}
              onClick={() => onChange(option.value)}
              isMultiSelect={false}
            />
            {option.value === 'other' && value === 'other' && (
              <OtherInputContainer>
                <OtherInput
                  type="text"
                  placeholder="Please describe your niche"
                  value={otherValue}
                  onChange={(e) => onOtherChange(e.target.value)}
                  autoFocus
                />
              </OtherInputContainer>
            )}
          </div>
        ))}
      </OptionsGrid>
    </div>
  )
}
